/* OCBA - offers + delivery layer.
   Three jobs:
     1. Rewrite every "free over 35 pounds" delivery claim so the page matches
        what checkout actually charges (standard free with no minimum, express
        5.99).
     2. Put a compact offers strip under the add-to-cart row on product pages.
        The multi-buy ladder is deliberately NOT repeated here - the theme's
        own .ocba-tier-wrapper grid already shows it further up the column.
     3. Show the live offers once, at the moment the customer clicks checkout,
        and carry NEW10 through with them.
   Nothing here invents data: every line is a real discount or a real rate. */
(function () {
  'use strict';

  var CFG = {};
  try {
    CFG = JSON.parse(document.getElementById('ocba-offers-data').textContent);
  } catch (e) {
    return;
  }

  var SEEN_KEY = 'ocba-offer-sheet-seen';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------------ */
  /* 1. Delivery copy                                                    */
  /* ------------------------------------------------------------------ */

  /* Ordered most-specific first. Applied to text nodes only, so no markup
     can be damaged by a replacement. */
  var PHRASES = [
    [/FREE\s+OVER\s+£\s?35/g, 'ALWAYS FREE'],
    [/Free\s+over\s+£\s?35/gi, 'Always free'],
    [/£\s?5\.99\s+on\s+orders?\s+under\s+£\s?35/gi, 'No minimum spend on any UK order'],
    [/Free\s+UK\s+Shipping\s+Over\s+£\s?35/gi, 'Free UK Delivery, Every Order'],
    [/free\s+(uk\s+)?(shipping|delivery)\s+(?:on\s+)?(?:all\s+)?(?:orders?\s+)?(?:over|above)\s+£\s?35/gi, 'Free UK delivery on every order'],
    [/(?:on\s+)?orders?\s+(?:over|above)\s+£\s?35/gi, 'on every order'],
    [/(?:over|above)\s+£\s?35/gi, 'on every order']
  ];

  function rewriteText(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('35') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p || p.nodeName === 'SCRIPT' || p.nodeName === 'STYLE' || p.nodeName === 'NOSCRIPT') {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function (node) {
      var before = node.nodeValue, after = before;
      for (var i = 0; i < PHRASES.length; i++) {
        var next = after.replace(PHRASES[i][0], PHRASES[i][1]);
        if (next !== after) { after = next; break; }
      }
      if (after !== before) node.nodeValue = after;
    });
  }

  /* The express price is fixed by selector rather than by matching the old
     figure, so it stays correct even if the theme's number changes. */
  function fixExpressPrice(root) {
    $$('.express-tier .rate-price', root).forEach(function (el) {
      if (el.textContent.trim() !== CFG.expressPrice) el.textContent = CFG.expressPrice;
    });
    $$('.standard-tier .rate-price', root).forEach(function (el) {
      var t = el.textContent.trim();
      if (/35/.test(t) || /^£\s?0/.test(t)) el.textContent = 'ALWAYS FREE';
    });
  }

  function sweep(root) {
    rewriteText(root || document.body);
    fixExpressPrice(root || document);
  }

  /* ------------------------------------------------------------------ */
  /* 2. Offers strip on the product page                                 */
  /* ------------------------------------------------------------------ */

  function tierLine() {
    return (CFG.tiers || []).map(function (t) {
      return 'Buy ' + t.q + ' save ' + t.off;
    }).join(' · ');
  }

  function buildStrip() {
    if (CFG.page !== 'product') return;
    if ($('.ocba-offers')) return;

    var row = $('.pvGroup-row');
    if (!row || !row.parentNode) return;

    var box = document.createElement('div');
    box.className = 'ocba-offers';

    var rows = [
      { code: CFG.code, text: CFG.codeLabel + ' - we apply it for you at checkout.' },
      { text: 'Free UK delivery on every order. No minimum spend.' },
      { text: 'Express next business day ' + CFG.expressPrice + '. Order before 2pm and it leaves the same working day.' }
    ];

    var html = '<div class="ocba-offers__head">Offers on this order</div><ul class="ocba-offers__list">';
    rows.forEach(function (r) {
      html += '<li>' +
        (r.code
          ? '<button type="button" class="ocba-offers__code" data-code="' + r.code + '">' + r.code + '</button>'
          : '<span class="ocba-offers__tick" aria-hidden="true">&#10003;</span>') +
        '<span>' + r.text + '</span></li>';
    });
    html += '</ul><p class="ocba-offers__note">Discounts are applied to your basket at checkout, so the total you see there is the total you pay.</p>';
    box.innerHTML = html;

    row.parentNode.insertBefore(box, row.nextSibling);

    var codeBtn = $('.ocba-offers__code', box);
    if (codeBtn) {
      codeBtn.addEventListener('click', function () {
        var code = codeBtn.getAttribute('data-code');
        var done = function () {
          codeBtn.classList.add('is-copied');
          codeBtn.textContent = 'COPIED';
          setTimeout(function () {
            codeBtn.classList.remove('is-copied');
            codeBtn.textContent = code;
          }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          done();
        }
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* 3. Offer sheet at the moment of checkout                            */
  /* ------------------------------------------------------------------ */

  /* Ella renders the cart-page button as #cart-checkout and the mini-cart
     button as #cart-sidebar-checkout; both carry .button-checkout. The
     accelerated wallet buttons are deliberately NOT matched. */
  var CHECKOUT_SEL = [
    '#cart-checkout',
    '#cart-sidebar-checkout',
    '.button-checkout',
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href$="/checkout"]',
    'a[href*="/checkout?"]',
    '.cart__checkout-button',
    '.btn-proceed-checkout'
  ].join(',');

  var sheet = null;
  var lastFocus = null;

  function checkoutUrl() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base + 'discount/' + encodeURIComponent(CFG.code) +
           '?redirect=' + encodeURIComponent(base + 'checkout');
  }

  function buildSheet() {
    if (sheet) return sheet;

    var rows = [
      {
        badge: CFG.code,
        title: CFG.codeLabel,
        sub: 'We will add this code for you on the next screen.'
      },
      {
        badge: 'FREE',
        plain: true,
        title: 'Free UK delivery',
        sub: 'Every order, no minimum spend.'
      },
      {
        badge: 'AUTO',
        plain: true,
        title: tierLine(),
        sub: 'Already counted in your basket total, no code needed.'
      },
      {
        badge: CFG.expressPrice,
        plain: true,
        title: 'Express next business day',
        sub: 'Optional at checkout. Order before 2pm and it leaves the same working day.'
      }
    ];

    var html =
      '<div class="ocba-sheet__backdrop" data-ocba-close></div>' +
      '<div class="ocba-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="ocba-sheet-title">' +
      '<button type="button" class="ocba-sheet__close" data-ocba-close aria-label="Close">&times;</button>' +
      '<p class="ocba-sheet__eyebrow">Before you check out</p>' +
      '<h2 class="ocba-sheet__title" id="ocba-sheet-title">These are live on your order</h2>' +
      '<ul class="ocba-sheet__rows">';

    rows.forEach(function (r) {
      html += '<li><span class="ocba-sheet__badge' + (r.plain ? ' ocba-sheet__badge--plain' : '') + '">' +
        r.badge + '</span><span><strong>' + r.title + '</strong><small>' + r.sub + '</small></span></li>';
    });

    html += '</ul>' +
      '<button type="button" class="ocba-sheet__cta" data-ocba-go>Continue to checkout</button>' +
      '<button type="button" class="ocba-sheet__back" data-ocba-close>Keep shopping</button>' +
      '</div>';

    sheet = document.createElement('div');
    sheet.className = 'ocba-sheet';
    sheet.hidden = true;
    sheet.innerHTML = html;
    document.body.appendChild(sheet);

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-ocba-go]')) {
        window.location.href = checkoutUrl();
        return;
      }
      if (e.target.closest('[data-ocba-close]')) closeSheet();
    });

    return sheet;
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openSheet(trigger) {
    lastFocus = trigger || document.activeElement;
    buildSheet().hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var cta = $('[data-ocba-go]', sheet);
    if (cta) cta.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet();
  });

  /* Capture phase so the theme's own cart handlers do not fire first.
     Shown at most once per session - after that, checkout is never delayed. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(CHECKOUT_SEL) : null;
    if (!t) return;
    if (t.closest('.ocba-sheet')) return;

    var seen;
    try { seen = sessionStorage.getItem(SEEN_KEY); } catch (err) { seen = '1'; }
    if (seen) return;

    e.preventDefault();
    e.stopPropagation();
    try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (err) {}
    openSheet(t);
  }, true);

  /* ------------------------------------------------------------------ */
  /* Boot                                                                */
  /* ------------------------------------------------------------------ */

  function init() {
    sweep(document.body);
    buildStrip();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* The shipping carousel clones its slides and the cart drawer re-renders,
     so re-run the sweep on anything the theme adds later. Debounced. */
  var pending = null;
  new MutationObserver(function (muts) {
    var added = false;
    for (var i = 0; i < muts.length && !added; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) added = true;
    }
    if (!added || pending) return;
    pending = setTimeout(function () {
      pending = null;
      sweep(document.body);
      buildStrip();
    }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();